import { getHeaders } from '../../core/actions/xhrRequest';
import { createAction } from 'redux-api-middleware';

export const FETCH_PAYMENT_INIT = 'FETCH_PAYMENT_INIT';
export const FETCH_PAYMENT_SUCCESS = 'FETCH_PAYMENT_SUCCESS';
export const FETCH_PAYMENT_FAILURE = 'FETCH_PAYMENT_FAILURE';

export const getPayments = () => createAction({
    types: [
        FETCH_PAYMENT_INIT,
        {
            type: FETCH_PAYMENT_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    let payments = Object.values(json);

                    payments.sort((a, b) => {
                        if (parseInt(a.priority) < parseInt(b.priority)) return 1;
                        if (parseInt(a.priority) > parseInt(b.priority)) return -1;
                        return 0;
                    });

                    return {
                        payments: payments,
                    };
                });
            }
        },
        FETCH_PAYMENT_FAILURE
    ],
    endpoint: `/api/payment/payment-methods`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});
